import { apolloClient } from "../../../vue-apollo";
import {
  ESTADOS_RECONOCE,
  TIPO_BENEFICIO,
  GET_GERENCIAS_ALL,
} from "@/apollo/queries";
import { exQue } from "@/utils/gql";
import {
  DASHBOARD_BENEFICIO,
  LIST_ADMIN_BENEFICIO,
  ELEMENTS_TIPOS_SOLICITUD,
  LIST_PAGINADA_SOLICIUDES,
  PAGINA_LIST_BENEFICIOS,
} from "@/apollo/queries/benefit";

import { stateSettings, mutationsSettings, actionsSettings } from "./storeSettings.js";
import { CHANGE_STATE_BENEF } from "@/apollo/mutations/benefit/index.js";

export default {
  namespaced: true,
  state: {
    benefit_list_edits: [],
    id_type_solicitud: 0,
    tab_component: [
      { name: "Dashboard", route: "benefit-Dashboard" },
      //{ name: "Configuración", route: "benefit-settings" },
    ],
    data_estados: [],
    final_list: [],
    paginas_solicitud: [],
    termimno_carga: true,
    dash_data: {},
    series: [],
    v_chartOptions: [],
    key_chart: 0,
    benefit_configs: [],
    gerencias: [],
    gerenciasLoading: false,
    tipoBeneImg: {},
    ...stateSettings,
  },
  mutations: {
    setGerencias(state, gerencias) {
      state.gerencias = gerencias;
    },
    setGerenciasLoading(state, loading) {
      state.gerenciasLoading = loading;
    },
    getAdminListSoli(state, soli) {
      if (soli.length > 0) {
        let filtro_data = soli.map(function (element) {
          element.check = false;
          return element;
        });
        state.final_list = filtro_data;
      } else {
        state.final_list = [];
      }
      state.termimno_carga = !state.termimno_carga;
    },
    addAdminListSoli(state, soli) {
      if (state.benefit_list_edits[Number(soli.id)] != undefined) {
        state.benefit_list_edits[Number(soli.id)].push(soli.data);
      } else {
        state.benefit_list_edits[Number(soli.id)] = [];
        state.benefit_list_edits[Number(soli.id)].push(soli.data);
      }
      state.final_list = soli.data;
    },
    changIdSolicitud(state, id) {
      state.id_type_solicitud = id;
    },
    // setea todo los tipos de solicitudes del cliente
    SET_TIPO_BENEFICIOS(state, data) {
      state.tab_component = [];
      state.tab_component = [{ name: "Dashboard", route: "benefit-Dashboard" }];
      state.tipoBeneImg = {};
      data.forEach((type) => {
        state.tipoBeneImg[type.id_tipo] = type.url_imagen || null;
        state.tab_component.push({
          name: type.nombre_solicitud,
          route: "solici-request",
          id: `${type.id_tipo}`,
        });
      });
      //state.tab_component.push({
      //  name: "Configuración",
      //  route: "benefit-settings",
      //});
    },

    SET_ESTADOS_SOLICITUDES(state, datos) {
      state.data_estados = [];
      datos.forEach((element) =>
        state.data_estados.push({
          id: element.id_estado_solicitud,
          type: element.__typename,
          label: element.nombre,
        }),
      );
    },

    SET_CHANGE_LIST_BENEFICIO(state, response) {
      let found_index = state.final_list.findIndex(
        (datos) => datos.id_solicitud == response.id_solicitud,
      );
      state.final_list.splice(found_index, 1);
    },

    SET_PAGINADOR_SOLICITUD(state, datos) {
      state.paginas_solicitud = datos;
    },
    SET_DASHBOARD_BENEFICIO(state, datos) {
      state.series = [];
      state.v_chartOptions = [];
      datos.solicitudes_tipo.forEach((solicitud) => {
        state.v_chartOptions.push(solicitud.nombre_solicitud);
        state.series.push(Number(solicitud.cantidad_solicitudes));
      });
      state.dash_data = datos;
      state.key_chart = state.key_chart + 1;
    },

    SET_BENEFIT_CONFIGS(state, datos) {
      state.benefit_configs = datos;
    },

    UPDATE_BENEFIT_CONFIG(state, config) {
      const idx = state.benefit_configs.findIndex(
        (c) => c.id_tipo === config.id_tipo,
      );
      if (idx !== -1) {
        state.benefit_configs.splice(idx, 1, config);
      } else {
        state.benefit_configs.push(config);
      }
    },

    ADD_LISTA_SOLICITUDES(state, datos) {
      let filtro_data = datos.map(function (element) {
        element.check = false;
        return element;
      });
      filtro_data.forEach(function (dato) {
        state.final_list.push(dato);
      });
      state.termimno_carga = !state.termimno_carga;
    },
    ...mutationsSettings,
  },
  actions: {
    async getGerencias({ commit }, idEmpresa) {
      commit("setGerenciasLoading", true);
      const gerencias = await exQue(GET_GERENCIAS_ALL, { idEmpresa }, true);
      commit("setGerencias", gerencias);
      commit("setGerenciasLoading", false);
    },
    // obtener lita de tipos de solicitudes asociadas al cliente
    async getTipoDeSolicitudes({ commit }, data_) {
      let response = {};
      let data = {};
      let params = {
        query: TIPO_BENEFICIO,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) data = res.data.TipoSolicitudes;
          response = data;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("SET_TIPO_BENEFICIOS", response);
          resolve(response);
        } else {
          resolve(null);
        }
      });
    },
    // obtener beneficios
    async getAdminListSoliAction({ commit }, data_) {
      let response = {};
      let data = {};
      let params = {
        query: LIST_ADMIN_BENEFICIO,
        variables: data_,
        fetchPolicy: "network-only",
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) data = res.data.ListSolicitudesAdmin;
          response = data;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("getAdminListSoli", response);
          resolve(response);
        } else {
          resolve(null);
        }
      });
    },
    // Obtener lista de solicitudes paginadas
    async getPaginacionSolicitudes({ commit }, data_) {
      let response = null;
      let params = {
        query: PAGINA_LIST_BENEFICIOS,
        variables: data_,
        fetchPolicy: "network-only",
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.PaginasSolicitudesAdmin;
        });
      } catch (e) {
        console.error(e);
        //return false
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            commit("getAdminListSoli", []);
            resolve(false);
          } else {
            resolve(response);
            commit("SET_PAGINADOR_SOLICITUD", response);
          }
        } else {
          resolve(false);
        }
      });
    },
    // Obtiene una lista de solicitudes paginadas, se debe ocupar el metodo getPaginacionSolicitudes primero
    async getListSolicitudes({ commit }, data_) {
      let response = null;
      let params = {
        query: LIST_PAGINADA_SOLICIUDES,
        variables: data_,
        fetchPolicy: "network-only",
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.ListSolicitudesAdminById;
        });
      } catch (e) {
        console.error(e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            commit("getAdminListSoli", response);
            resolve(false);
          } else {
            resolve(response);
            commit("getAdminListSoli", response);
          }
        } else {
          resolve(false);
        }
      });
    },
    // obtiene las solicitudes, paginadas, pero llama a otro state, dado que en este caso hace un push
    async getListSolicitudesAppend({ commit }, data_) {
      let response = null;
      let params = {
        query: LIST_PAGINADA_SOLICIUDES,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.ListSolicitudesAdminById;
        });
      } catch (e) {
        console.error(e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("ADD_LISTA_SOLICITUDES", response);
          }
        } else {
          resolve(false);
        }
      });
    },
    // obtener los datos de un tipo de beneficio
    async getTipoBeneficio({ commit }, data_) {
      let response = {};
      let data = {};
      let params = {
        query: ELEMENTS_TIPOS_SOLICITUD,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading)
            data = res.data.ListarAllElementsTiposSolicitudAdmin;
          response = data;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("SET_TIPO_BENEFICIO", response);
          resolve(response);
        } else {
          resolve(null);
        }
      });
    },
    // mutacion para cambio de estado de solicitudes de beneficios
    async cambioEstadoSolicitud({ commit }, data_) {
      let response = null;
      let data = [];
      let params = {
        mutation: CHANGE_STATE_BENEF,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) data = res.data.ChangeEstadoSolicitud;
          response = data;
        });
      } catch (e) {
        console.error(e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("SET_CHANGE_LIST_BENEFICIO", response);
        } else {
          resolve(false);
        }
      });
    },
    // obtener estados de las solicitudes
    async getEstadosSolicitud({ commit }, data_) {
      let response = {};
      let data = {};
      let params = {
        query: ESTADOS_RECONOCE,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) data = res.data.ListEstadosSolicitudes;
          response = data;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("SET_ESTADOS_SOLICITUDES", response);
          resolve(response);
        } else {
          resolve(null);
        }
      });
    },
    // añadir beneficios editados
    async addAdminListSoliAction({ commit }, soli) {
      commit("addAdminListSoli", soli);
    },
    // añadir beneficios editadosss
    async changIdSolicitudAction({ commit }, id) {
      commit("changIdSolicitud", id);
    },
    // obtener configuraciones de beneficios
    async getBenefitConfigs({ commit }, data_) {
      let response = null;
      const params = {
        // query: CONFIGURACION_BENEFICIOS,
        variables: data_,
        fetchPolicy: "network-only",
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.ConfiguracionBeneficios;
        });
      } catch (e) {
        console.error(e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("SET_BENEFIT_CONFIGS", response);
          resolve(response);
        } else {
          resolve([]);
        }
      });
    },

    // actualizar configuracion de un tipo de beneficio
    async updateBenefitConfig({ commit }, data_) {
      let response = null;
      const params = {
        // mutation: UPDATE_CONFIGURACION_BENEFICIO,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) response = res.data.UpdateConfiguracionBeneficio;
        });
      } catch (e) {
        console.error(e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("UPDATE_BENEFIT_CONFIG", response);
          resolve(response);
        } else {
          resolve(null);
        }
      });
    },

    // getDashboard
    async getDashboard({ commit }, payload) {
      let response = {};
      let data = {};
      let params = {
        query: DASHBOARD_BENEFICIO,
        variables: payload,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) data = res.data.DashboardSolicitud;
          response = data;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("SET_DASHBOARD_BENEFICIO", response);
          resolve(response);
        } else {
          resolve(null);
        }
      });
    },
    ...actionsSettings,
  },
  getters: {
    configPorTipoSolicitud(state) {
      if (!state.FindPeriodosCondicionesEmpresa) return {};
      return state.FindPeriodosCondicionesEmpresa.reduce((map, item) => {
        const periodos = item.periodos || [];
        const condiciones = item.condiciones || [];

        // Derivar tipo y campos relacionados desde periodos
        let tipo = "siempre";
        let dias_semana = [1, 2, 3, 4, 5, 6, 7];
        let rangos = [];

        const periodoDias = periodos.filter(
          (p) => p.tipo && (p.tipo.is_dia === true || p.tipo.is_dia === "true")
        );
        const periodoRangos = periodos.filter(
          (p) => p.tipo && (p.tipo.is_rango === "true" || p.tipo.is_rango === true)
        );

        if (periodoRangos.length > 0) {
          tipo = "rangos";
          rangos = periodoRangos.map((p) => ({
            start: p.tiempo_inicio ? p.tiempo_inicio.split("T")[0] : null,
            end: p.tiempo_final ? p.tiempo_final.split("T")[0] : null,
          }));
        } else if (periodoDias.length > 0) {
          tipo = "dias_semana";
          dias_semana = periodoDias
            .map((p) => Number(p.tiempo_dia))
            .filter((d) => d > 0);
        }

        // Derivar restricciones y campos relacionados desde condiciones
        const restricciones = [];
        let areas_restringidas = [];
        let genero = null;
        let tiempo_compania_criterio = null,
          tiempo_compania_valor_1 = null,
          tiempo_compania_valor_2 = null;
        let nacimiento_criterio = null,
          nacimiento_valor_1 = null,
          nacimiento_valor_2 = null;

        condiciones.forEach((condicion) => {
          if (condicion.c_area && condicion.c_area.length > 0 && !restricciones.includes("area")) {
            restricciones.push("area");
            areas_restringidas = [].concat(condicion.c_area);
          }
          if (
            (condicion.c_ingreso_desde !== null || condicion.c_ingreso_hasta !== null) &&
            !restricciones.includes("tiempo_compania")
          ) {
            restricciones.push("tiempo_compania");
            const desde = condicion.c_ingreso_desde !== null ? Number(condicion.c_ingreso_desde) : null;
            const hasta = condicion.c_ingreso_hasta !== null ? Number(condicion.c_ingreso_hasta) : null;
            if (desde !== null && hasta !== null) {
              tiempo_compania_criterio = 2;
              tiempo_compania_valor_1 = desde;
              tiempo_compania_valor_2 = hasta;
            } else if (desde !== null) {
              tiempo_compania_criterio = 0;
              tiempo_compania_valor_1 = desde;
            } else if (hasta !== null) {
              tiempo_compania_criterio = 1;
              tiempo_compania_valor_1 = hasta;
            }
          }
          if (
            condicion.c_genero !== null &&
            condicion.c_genero !== undefined &&
            !restricciones.includes("genero")
          ) {
            restricciones.push("genero");
            genero = Number(condicion.c_genero);
          }
          if (
            (condicion.c_nacimiento_desde !== null || condicion.c_nacimiento_hasta !== null) &&
            !restricciones.includes("nacimiento")
          ) {
            restricciones.push("nacimiento");
            const desde = condicion.c_nacimiento_desde !== null ? Number(condicion.c_nacimiento_desde) : null;
            const hasta = condicion.c_nacimiento_hasta !== null ? Number(condicion.c_nacimiento_hasta) : null;
            if (desde !== null && hasta !== null) {
              nacimiento_criterio = 2;
              nacimiento_valor_1 = desde;
              nacimiento_valor_2 = hasta;
            } else if (desde !== null) {
              nacimiento_criterio = 0;
              nacimiento_valor_1 = desde;
            } else if (hasta !== null) {
              nacimiento_criterio = 1;
              nacimiento_valor_1 = hasta;
            }
          }
        });

        map[String(item.id_tipo_solicitud_fk)] = {
          id_tipo: String(item.id_tipo_solicitud_fk),
          id_solicitud_empresa: String(item.id_solicitud_empresa),
          habilitado: true,
          tipo,
          dias_semana,
          rangos,
          restricciones,
          areas_restringidas,
          genero,
          tiempo_compania_criterio,
          tiempo_compania_valor_1,
          tiempo_compania_valor_2,
          nacimiento_criterio,
          nacimiento_valor_1,
          nacimiento_valor_2,
        };

        return map;
      }, {});
    },
  },
};
